import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "core/gd-components/base-component/base-component";

export default class DndPreviewLayerComponent extends BaseComponent {

    static propTypes = {
        dndLayerName: PropTypes.string.isRequired,
        dndManager: PropTypes.object
    };

    static defaultProps = {
        dndLayerName: 'default'
    };

    constructor(props) {
        super(props);

        this.state = {
            source: null
        };

        this._bind('showPreview', 'hidePreview', 'updatePreview')
    }

    componentDidMount() {
        if (this.props.dndManager) this.props.dndManager.registerDndLayer(this, this.props.dndLayerName);
    }

    componentWillUnmount() {
        if (this.props.dndManager) this.props.dndManager.unregisterDndLayer(this, this.props.dndLayerName);
    }

    showPreview(source, mouseEvent) {
        //should be overridden
    }

    hidePreview() {
        //should be overridden
    }

    updatePreview(dx = 0, dy = 0) {
        //should be overridden
    }

    render() {
        return (
            <div className="gd-dnd-layer"/>
        );
    }
}